import { Badge as MuiBadge, BadgeOrigin, styled } from '@mui/material'
import { CallType } from '@weblite/ts-action/media-proxy'
import { LiveBadge } from '$common/live-badge'
import { OnlineBadge } from '$common/badge/online-badge'
import { SelectedBadge } from '$common/badge/selected-badge'
import { ActiveAudioWaves } from '$common/active-audio-waves'
import { TribuneActiveAudioWaves } from '$common/tribune-active-audio-waves'

const Badge = styled(MuiBadge)`
  &.MuiBadge-root {
    width: fit-content;
    height: fit-content;
    padding: 0;
  }
`

export function BadgeWrapper({
  selected,
  online = false,
  ongoingCallType,
  children,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  },
}: {
  selected: boolean | undefined
  online?: boolean
  ongoingCallType?: CallType
  children: JSX.Element
  anchorOrigin?: BadgeOrigin
}) {
  return (
    <Badge
      overlap="circular"
      invisible={!(selected || online || ongoingCallType)}
      anchorOrigin={anchorOrigin}
      badgeContent={
        ongoingCallType === 'group_call' ? (
          <ActiveAudioWaves hasStroke />
        ) : ongoingCallType === 'live' ? (
          <LiveBadge />
        ) : ongoingCallType === 'tribune' ? (
          <TribuneActiveAudioWaves hasStroke />
        ) : selected ? (
          <SelectedBadge />
        ) : online ? (
          <OnlineBadge />
        ) : null
      }
    >
      {children}
    </Badge>
  )
}
